<template>
	<div class="tpl trend-list-wrap" :class="{'tree-header':selected==3}">
		<div class="trend-list-header" :class="{'tree-header':selected==3}">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">动态</mt-tab-item>
				<mt-tab-item id="2">好友</mt-tab-item>
				<mt-tab-item id="3">树洞</mt-tab-item>
			</mt-navbar>
			<router-link :to="{name:'trend-notice',query:{selected:selected}}" class="friend-list-btn">
				<img src="../../assets/img/trends/dyn_dyn_ic_Message.png" />
			</router-link>
		</div>
		<mt-tab-container v-model="selected">
			<mt-tab-container-item id="1">
				<div class="trend-all-wrap">
					<mt-loadmore :top-method="refreshAllList" :bottom-method="loadMoreAllList" :auto-fill="false" ref="loadmoreall">
						<trend-item v-for="item in trendsAllList" :key="item.d_id" :uid="uid" :itemInfo="item" @deleteItem="deleteItem" @click.native="goToDetail(item.d_id,'1')"></trend-item>
						<div class="no-content" v-if="trendsAllList.length<1">
							<img src="../../assets/img/default/bg_img_nothing@2x.png"/>
							<p>没有内容？刷新试试？</p>
						</div>
					</mt-loadmore>
					<div class="send-trend-btn">
						<!--<router-link class="go-to-send" :to="{name:'send-trends'}">+</router-link>-->
						<router-link class="go-to-send" :to="{name:'send-trends'}"><img src="../../assets/img/finds/btn_find_list_publish@2x.png"/></router-link>
					</div>
				</div>
			</mt-tab-container-item>
			<mt-tab-container-item id="2">
				<div class="trend-all-wrap">
					<mt-loadmore :top-method="refreshFriendList" :bottom-method="loadMoreFriendList" :auto-fill="false" ref="loadmorefriend">
						<trend-item v-for="item in trendsFriendList" :key="item.d_id" :uid="uid" :itemInfo="item" @deleteItem="deleteItem" @click.native="goToDetail(item.d_id,'2')"></trend-item>
						<div class="no-content" v-if="trendsFriendList.length<1">
							<img src="../../assets/img/default/bg_img_nothing@2x.png"/>
							<p>没有内容？刷新试试？</p>
						</div>
					</mt-loadmore>
					<div class="send-trend-btn">
						<router-link class="go-to-send" :to="{name:'send-trends'}"><img src="../../assets/img/finds/btn_find_list_publish@2x.png"/></router-link>
					</div>
				</div>
			</mt-tab-container-item>
			<mt-tab-container-item id="3">
				<div class="tree-banner">
					<div class="swiper-container">
					    <div class="swiper-wrapper">
					      <div class="swiper-slide" v-for="item in trendsTreeList.banner"><a :href="item.link"><img :src="item.img"/></a></div>
					    </div>
					    <div class="swiper-pagination"></div>
					</div>
				</div>
				<div class="tree-list">
					<mt-loadmore :top-method="refreshTreeList" :bottom-method="loadMoreTreeList" :auto-fill="false" ref="loadmoretree">
						<div class="tree-item" v-for="item in trendsTreeList.TreeHoleList" @click="goToTreeDetail(item.t_id,'3')">
							<div class="item-header">
								<div class="item-title">
									<img src="../../assets/img/trends/dyn_tree_ic_anony.png"/>
									<span class="title-content">{{item.title}}</span>
									<span class="tag-hot" v-if="item.hot==1">热</span>
								</div>
								<mt-button icon="more" slot="right"></mt-button>
							</div>
							<div class="item-content">
								<p>{{item.text}}</p>
							</div>
							<div class="item-related">
								<span class="item-time">发布于{{item.create_time | toDateTime | convertTime("YYYY.MM.DD")}}</span>
								<span class="item-view">{{item.views}}人看过</span>
							</div>
						</div>
						<div class="no-content" v-if="trendsTreeList.TreeHoleList&&trendsTreeList.TreeHoleList.length<1">
							<img src="../../assets/img/default/bg_img_nothing@2x.png"/>
							<p>没有内容？刷新试试？</p>
						</div>
					</mt-loadmore>
					<div class="send-trend-btn">
						<router-link class="go-to-send" :to="{name:'send-tree-hole'}"><img src="../../assets/img/finds/btn_find_list_publish@2x.png"/></router-link>
					</div>
				</div>
			</mt-tab-container-item>
		</mt-tab-container>
	</div>
</template>

<script>
	
	import TrendItem from "./TrendItem"
	
	import 'swiper/dist/css/swiper.css';

	import Swiper from 'swiper';
	
	export default {
		name: "trends",
		components:{
			TrendItem
		},
		data() {
			return {
				uid:"",
				selected: "1",
				trendsAllList:"",
				trendsAllListNowPage:1,
				trendsFriendList:"",
				trendsFriendListNowPage:1,
				trendsTreeList:"",
				trendsTreeListNowPage:1,
				value: "",
				result: [
					//					{title:"name",value:"zhou"},
					//					{title:"name",value:"zhou"},
					//					{title:"name",value:"zhou"},
					//					{title:"name",value:"zhou"},
				]
			}
		},
		mounted(){
			
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","trends");
			this.$store.commit("changeTabBarShow",true);
			
			this.selected = this.$route.query.selected || "1";
			
			this.getTrendsAllList();
		},
		watch:{
			selected(){
				console.log(this.selected)
				if(this.selected==1){
					this.getTrendsAllList();
				}else if(this.selected==2){
					this.getTrendsFriendList();
				}else if(this.selected==3){
					this.getTrendsTreeList();
					setTimeout(function(){
						new Swiper('.swiper-container',{
							autoplay: true,
							loop: true,
							pagination: {
								el: '.swiper-pagination'
							},
						});
					},500)
				}
			}
		},
		methods:{
			getTrendsAllList(){
				this.$axios({
					url:"Dynamic/DynamicList",
					method:"post",
					data:{
						page:this.trendsAllListNowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.trendsAllListNowPage==1){
							this.$toast({
								message:"加载成功~",
								position:"bottom",
								duration:3000
							})
							this.trendsAllList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.trendsAllListNowPage--;
							}else{
								this.$toast({
									message:"加载成功~",
									position:"bottom",
									duration:3000
								})
								this.trendsAllList = this.trendsAllList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"加载失败了~",
							position:"bottom",
							duration:3000
						})
						this.trendsAllListNowPage--;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getTrendsFriendList(){
				if(!this.isLogin()){return false;}
				this.$axios({
					url:"Dynamic/MyFriendsDynamicList",
					method:"post",
					data:{
						uid:this.uid,
						page:this.trendsFriendListNowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.trendsFriendListNowPage==1){
							this.$toast({
								message:"加载成功~",
								position:"bottom",
								duration:3000
							})
							this.trendsFriendList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.trendsFriendListNowPage--;
							}else{
								this.$toast({
									message:"加载成功~",
									position:"bottom",
									duration:3000
								})
								this.trendsFriendList = this.trendsFriendList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"加载失败了~",
							position:"bottom",
							duration:3000
						})
						this.trendsFriendListNowPage--;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getTrendsTreeList(){
				this.$axios({
					url:"Dynamic/TreeHoleList",
					method:"post",
					data:{
						page:this.trendsTreeListNowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.trendsTreeListNowPage==1){
							this.$toast({
								message:"加载成功~",
								position:"bottom",
								duration:3000
							})
							this.trendsTreeList = res.data.data;
						}else{
							if(res.data.data.TreeHoleList.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.trendsTreeListNowPage--;
							}else{
								this.$toast({
									message:"加载成功~",
									position:"bottom",
									duration:3000
								})
								this.trendsTreeList.TreeHoleList = this.trendsTreeList.TreeHoleList.concat(res.data.data.TreeHoleList);
							}
						}
					}else{
						this.$toast({
							message:"加载失败了~",
							position:"bottom",
							duration:3000
						})
						this.trendsTreeListNowPage--;
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			deleteItem(data){
				console.log(data);
				if(data==200){
					if(this.selected=="1"){
						this.getTrendsAllList();
					}else if(this.selected=="2"){
						this.getTrendsFriendList();
					}else if(this.selected=="3"){
						this.getTrendsTreeList();
					}
				}
			},
			goToDetail(id,s){
				this.$router.push({
					name:"trend-detail",
					query:{
						id:id,
						selected:s
					}
				})
			},
			goToTreeDetail(id,s){
				this.$router.push({
					name:"tree-hole-detail",
					query:{
						id:id,
						selected:s
					}
				})
			},
			refreshAllList(){
				this.trendsAllListNowPage = 1;
				this.getTrendsAllList();
				this.$refs.loadmoreall.onTopLoaded();
			},
			loadMoreAllList(){
				this.trendsAllListNowPage++;
				this.getTrendsAllList();
				this.$refs.loadmoreall.onBottomLoaded();
			},
			refreshFriendList(){
				this.trendsFriendListNowPage = 1;
				this.getTrendsFriendList();
				this.$refs.loadmorefriend.onTopLoaded();
			},
			loadMoreFriendList(){
				this.trendsFriendListNowPage++;
				this.getTrendsFriendList();
				this.$refs.loadmorefriend.onBottomLoaded();
			},
			refreshTreeList(){				
				this.trendsTreeListNowPage = 1;
				this.getTrendsTreeList();
				this.$refs.loadmoretree.onTopLoaded();
			},
			loadMoreTreeList(){
				this.trendsTreeListNowPage++;
				this.getTrendsTreeList();
				this.$refs.loadmoretree.onBottomLoaded();
			},
		}
		
	}
</script>

<style scoped>
	.mint-tab-container{
		min-height: calc(100vh - 6.48rem);
	}
	.trend-list-wrap {
		padding-top: 3rem;
		background: #f3f3f3;
		
	}
	
	.trend-list-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 0.5rem;
		position: fixed;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 10;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.mint-navbar {
		width: 50%;
	}
	
	>>>.mint-navbar .mint-tab-item {
		box-sizing: border-box;
	}
	
	>>>.mint-tab-item .mint-tab-item-label {
		/*transition: 300ms;*/
	}
	
	>>>.mint-tab-item.is-selected .mint-tab-item-label {
		font-size: 1rem;
		font-weight: bold;
		color: #5415f9;
	}
	
	>>>.mint-navbar .mint-tab-item.is-selected {
		border-bottom: 0;
	}
	
	.friend-list-btn img {
		width: 1.5rem;
	}
	
	.trend-all-wrap{
		overflow-y: scroll;
		height: calc(100vh - 6.5rem);
	}
	
	
	.tree-banner{
		position: relative;
		width: 100%;
		height: 10rem;
	}
	.swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
	.swiper-slide img{
		width: 100%;
		display: block;
	}
	>>>.swiper-pagination-bullet {
		width: 1rem;
		height: 0.3rem;
		border-radius: 1rem;
		background: #a5a5a5;
		transition: 300ms;
	}
	
	>>>.swiper-pagination-bullet-active {
		width: 1.5rem;
		background: #ff6161;
	}
	
	.tree-list{
		background: #282828;
		padding: 0 1rem;
		overflow-y: scroll;
		height: calc(100vh - 16rem);
	}
	>>>.tree-item{
		padding: 1rem;
		margin: 0.5rem 0;
		background: #fff;
		border-radius: 5px;
		
	}
	.tree-item .item-header{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.tree-item .item-title{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 1.2rem;
		color: #282828;
		font-weight: bold;
	}
	.tree-item .item-title .title-content{
		max-width: 12rem;
		text-overflow: ellipsis;
		white-space: nowrap;
    	overflow: hidden;
	}
	.tree-item .item-title .tag-hot{
		background: #fc7474;
	    color: #fff;
	    font-size: 0.65rem;
	    font-weight: normal;
	    width: 1.2rem;
	    height: 1.2rem;
	    text-align: center;
	    line-height: 1.2rem;
	    border-radius: 4px;
	    margin-left: 0.5rem;
	}
	.tree-item .item-title img{
		width: 2rem;
		display: block;
		border-radius: 4px;
		margin-right: 0.5rem;
	}
	.tree-item .mint-button{
		background: none;
	    border: 0;
	    box-shadow: none;
	    color: #6D34FB;
	}
	.tree-item .item-content{
		font-size: 0.85rem;
		line-height: 1.4rem;
		color: #686868;
		margin: 0.5rem 0;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}
	.tree-item .item-related{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.65rem;
		color: #9e9e9e;
	}
	.tree-header{
		background: #282828;
		border-bottom: 0;
	}
	.tree-header .mint-navbar{
		background: #282828;
	}
	.tree-header .mint-navbar >>>.mint-tab-item-label{
		color: #FFF;
	}
	.tree-header .mint-navbar >>>.mint-tab-item.is-selected .mint-tab-item-label{
		color: #5415F9;
	}
	.send-trend-btn{
	    position: fixed;
	    right: 0rem;
	    bottom: 3rem;
	}
	.send-trend-btn img{
		width: 5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/Trends.vue